import React from 'react';
import styled from 'styled-components';
import { useFavorites } from '../../context/FavoritesContext';
import ImageCard from '../gallery/ImageCard';

const FavoritesContainer = styled.div`
  padding: 2rem;
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 2rem;
  font-weight: 700;
`;

const EmptyMessage = styled.p`
  font-size: 1.2rem;
  color: #666;
  text-align: center;
  margin-top: 2rem;
`;

const ImagesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 1rem;
  
  @media (max-width: 1600px) {
    grid-template-columns: repeat(5, 1fr);
  }
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
  
  @media (max-width: 900px) {
    grid-template-columns: repeat(3, 1fr);
  }
  
  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const FavoritesGallery: React.FC = () => {
  const { favorites } = useFavorites();

  return (
    <FavoritesContainer>
      <Title>Mis Favoritos</Title>
      
      {favorites.length === 0 ? (
        <EmptyMessage>
          No tienes imágenes favoritas aún. Explora nuestra galería y agrega tus favoritas con el click derecho.
        </EmptyMessage>
      ) : (
        <ImagesGrid>
          {favorites.map(image => (
            <ImageCard key={image.id} image={image} />
          ))}
        </ImagesGrid>
      )}
    </FavoritesContainer>
  );
};

export default FavoritesGallery;